import gql from 'graphql-tag';

export const DISCONNECT_TIKTOK_SETTINGS_ACCOUNT = gql`
  mutation DisconnectTikTokSettingsAccountMutation($accountId: String!) {
    tiktokSettingsDisconnectAccount(accountId: $accountId)
  }
`;
